import useCarrotPlan from "components/carrot-plans/hooks/useCarrotPlan"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getConditionsSelector } from "../util/ConditionReduxMap"

function useToggableCondition(value: boolean): { value: boolean; toggle: () => void } {
  const [conditionOverride, setConditionOverride] = useState(value)
  const [override, setOverride] = useState(false)
  function toggleCondition(newValue?: boolean): void {
    if (newValue) {
      setConditionOverride(newValue)
    } else {
      setConditionOverride(override ? !conditionOverride : !value)
    }
    setOverride(true)
  }
  return {
    value: override ? conditionOverride : value,
    toggle: toggleCondition
  }
}

export function useContentfulConditions(): Record<string, { value: boolean; toggle: (condition?: boolean) => void }> {
  const { hasCarrotPlan } = useCarrotPlan()
  const dispatch = useDispatch()
  const reduxConditions = useSelector(getConditionsSelector(dispatch))
  const hasCarrotPlanCondition = useToggableCondition(hasCarrotPlan)

  return {
    ...reduxConditions,
    has_carrot_plan: hasCarrotPlanCondition
  }
}
